import {
    Alert,
    Button,
    CircularProgress,
    Container,
    Divider,
    Grid, IconButton, InputAdornment,
    Link,
    Stack,
    TextField,
    Typography
} from "@mui/material";
import React, {ChangeEvent, useState} from "react";
import {useNavigate} from "react-router";
import {useUserLoginContext} from "../Contexts/UserContext";
import {MutationManagementLoginMutationArgs, useManagementLoginMutation} from "../generated/graphql";
import {useSiteDataContext} from "../Contexts/SiteDataContext";
import {Visibility, VisibilityOff} from "@mui/icons-material";

function LoginPage() {
    const navigate = useNavigate();
    const setUser = useUserLoginContext();
    const [mutation,doLogin] = useManagementLoginMutation();
    const siteData = useSiteDataContext();
    const page =siteData.pages?.manageMySubscription;
    const [showPassword,setShowPassword] = useState(false);
    const [state,setState] = useState<MutationManagementLoginMutationArgs>({username:'',password:'',theatre:siteData?.siteData?.subdomain});
    const [error,setError] = useState('');
    function onChange(evt:ChangeEvent) {
        setState((oldState)=>{
            var target = evt.target as HTMLInputElement;
            var v = {...oldState};
            v[target.name as keyof MutationManagementLoginMutationArgs] = target.value;
            return v;
        });
    }
    function handleClickShowPassword() {
        setShowPassword((v)=>!v);
    }
    async function performLogin(evt) {
        evt.preventDefault();
        setError('');
        console.log('login state is',state);
        const result = await doLogin(state);
        if(!result?.data?.ManagementLoginMutation) {
            setError('Email or password is incorrect.');
            return;
        }
        if(result?.data?.ManagementLoginMutation?.error) {
            setError(result.data.ManagementLoginMutation.error);
            return;
        }
        if(result.data.ManagementLoginMutation.url) {
            window.location.href = result.data.ManagementLoginMutation.url as string;
        }
    }
    return (<Container maxWidth="md">
        <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
                <Typography typography="h1" color="primary">{page.title}</Typography>
                <Typography typography="subtitle" color="primary">{page.subtitle}</Typography>
                <Divider sx={
                    (theme)=>({
                        paddingTop:theme.spacing(2)
                    })}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                {!!error &&
                  <Alert severity="error" sx={(theme)=>({borderRadius: 0, marginBottom:theme.spacing(2)})}>{error}</Alert>
                }
                <form onSubmit={performLogin} className="bert">
                <TextField type="username" required={true} value={state.username} name="username" label="Username" fullWidth={true} variant="standard" onChange={onChange}/>
                <TextField name="password" required={true} value={state.password} label="Password" fullWidth={true} variant="standard" onChange={onChange} helperText={<Link underline="always" href={(siteData.siteData?.siteUrl)+"friends/Online/forgotPassword.asp"}>Forgot password?</Link>}
                InputProps={{endAdornment:
                        <InputAdornment position="end">
                    <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    edge="end"
                    >{showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                    </InputAdornment>,
                    type:showPassword?'text':'password'
                }}
                />
                <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
                    <Button type="submit" disabled={mutation.fetching} color="secondary" startIcon={mutation.fetching?<CircularProgress size="1rem"/>:null}
                     sx={(theme)=>({marginTop:theme.spacing(2)})} fullWidth={true} variant="contained" size="large">{page.button}</Button>

                </Stack>
                </form>
            </Grid>
        </Grid>
    </Container>);
}
export default LoginPage;